<script>
import $ from 'domtastic';
import isObject from 'lodash/isObject';
import each from 'lodash/each';
import map from 'lodash/map';
import vueMixins from 'viralstyle-ui/src/vueMixins';
import LayoutHeader from 'sales-flow-ui/components/Header';
import { mapState } from 'vuex';

class MenuLink {
  constructor(text, uri, showWhenUserLoggedIn, actionName, actionArgs, subMenu) {
    if (!text) {
      this.break = true;
    } else {
      this.text = text;
      this.uri = uri;
      this.showWhenUserLoggedIn = showWhenUserLoggedIn;
      this.actionName = actionName;
      this.actionArgs = actionArgs;
      this.subMenu = subMenu;
      this.subMenuOpen = false;
    }
  }
};

export default {
  components: {
    LayoutHeader,
  },
  mixins: [vueMixins],
  data: () => ({
    currentScrollTop: 0,
    prevSearch: null,
    menuLinks: [],
    marketplaceCategories: [],
  }),
  computed: {
    ...mapState([
      'processing',
      'headerCollapsed',
      'scrollingUp',
      'hideFixedHeader',
      'domainConfig',
      'search',
      'searchApplied',
      'collections',
    ]),
    ...mapState({
      cart: state => state.cart.cart,
    }),
    isMobile() {
      return this.$mq === 'sm' || this.$mq === 'md';
    },
    isMobileSalesPage() {
      return this.$route.name === 'sales' && this.isMobile;
    },
  },
  created() {
    if (this.collections && this.collections.length) {
      this.marketplaceCategories = map(this.collections, collection => ({ text: collection.name, value: collection.slug }));

      this.menuLinks.push(new MenuLink('Collections', { name: 'collections' }, null, null, null, [
        ...this.marketplaceCategories,
      ]));
    }

    this.menuLinks = [
      ...this.menuLinks,
      new MenuLink(),
    ];

    if (!this.domainConfig.assets.logo) {
      this.menuLinks.push(new MenuLink('Home', { name: 'home' }));
    }

    this.menuLinks = [
      ...this.menuLinks,
      new MenuLink('Track Order', { name: 'trackOrder' }),
      new MenuLink('Contact', { name: 'contact' }),
      new MenuLink('FAQ', { name: 'faq' }),
    ];
  },
  mounted() {
    this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    $(window).on('scroll', this.$_handleScroll);
  },
  beforeDestroy() {
    $(window).off('scroll', this.$_handleScroll);
  },
  methods: {
    async $_handleScroll() {
      let alreadyCollapsed = !this.headerCollapsed,
        fixedHeaderHidden = this.hideFixedHeader,
        alreadyScrollingUp = this.scrollingUp,
        searchInputs = document.querySelectorAll('.header-bottom__search input'),
        headerTop = document.querySelector('.header-top'),
        headerBottoms = document.querySelectorAll('.header-bottom');

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.updateState(this.$store.state, 'headerCollapsed', this.currentScrollTop > 20);

      let scrollingUp = this.currentScrollTop <= this.lastScrollTop;

      this.updateState(this.$store.state, 'scrollingUp', scrollingUp);

      if (this.isMobile) {
        this.updateState(this.$store.state, 'hideFixedHeader', this.currentScrollTop <= 0 ? true : alreadyScrollingUp && !fixedHeaderHidden ? false : this.currentScrollTop < 90 && scrollingUp);

        if (this.currentScrollTop === 0 && document.activeElement === searchInputs[1]) {
          searchInputs[0].focus();
        } else if (this.currentScrollTop > 0 && document.activeElement === searchInputs[0] && !this.hideFixedHeader) {
          searchInputs[1].focus();
        }
      } else {
        this.updateState(this.$store.state, 'hideFixedHeader', this.currentScrollTop <= 0);

        await this.$nextTick();

        if (this.currentScrollTop <= 0) {
          let focusedElement = headerBottoms[1].querySelector(':focus');

          if (focusedElement) {
            let fixedChildren = headerBottoms[1].getElementsByTagName('*'),
              staticChildren = headerBottoms[0].getElementsByTagName('*');

            each(fixedChildren, (child, index) => {
              if (child === document.activeElement) {
                staticChildren[index].focus();
              }
            })
          }

          if (this.$children[0].$refs.headerBottomFixed.showShopByMenu) {
            this.$children[0].$refs.headerBottomFixed.$_closeShopByMenu();
            this.$children[0].$refs.headerBottom.$refs.shopByMenu.click();
          }
        } else if (this.currentScrollTop >= 0 && !this.hideFixedHeader) {
          let focusedElement = headerBottoms[0].querySelector(':focus');

          if (focusedElement) {
            let fixedChildren = headerBottoms[1].getElementsByTagName('*'),
              staticChildren = headerBottoms[0].getElementsByTagName('*');

            each(staticChildren, (child, index) => {
              if (child === document.activeElement && fixedChildren[index].focus) {
                fixedChildren[index].focus();
              }
            })
          }

          if (this.$children[0].$refs.headerBottom.showShopByMenu) {
            this.$children[0].$refs.headerBottom.$_closeShopByMenu();
            this.$children[0].$refs.headerBottomFixed.$refs.shopByMenu.click();
          }
        }
      }

      this.lastScrollTop = this.currentScrollTop <= 0 ? 0 : this.currentScrollTop;
    },
    handleSearchInput(e) {
      this.$store.commit('updateState', { object: this.$store.state, property: 'search', value: e.target.value });
    },
    performSearch(e) {
      this.handleSearchInput(e);

      if ((e.target.value || !e.target.value && this.searchApplied) && this.prevSearch !== e.target.value) {
        this.$store.dispatch('getCampaigns', { page: 1 });
      }

      this.prevSearch = e.target.value;

      this.$store.commit('updateState', { object: this.$store.state, property: 'searchApplied', value: !!e.target.value });
    },
  },
};
</script>

<template lang='pug'>
layout-header(
  is-whitelabel,
  cart-route='cart',
  checkout-route='checkout',
  :cart='cart',
  :collapsed='headerCollapsed',
  :processing='processing',
  :search='search',
  :marketplace-categories='marketplaceCategories',
  :menu-links='menuLinks',
  :is-mobile='isMobile',
  :is-mobile-sales-page='isMobileSalesPage',
  :scrolling-up='scrollingUp',
  :hide-fixed-header='hideFixedHeader',
  :current-scroll-top='currentScrollTop',
  :show-home-link='!domainConfig.assets.logo',
  @search-input='handleSearchInput',
  @perform-search='performSearch',
)
  template(v-slot:logo='')
    router-link(:to='{ name: "home", params: { page: "1", nav: true } }', aria-label='Home link')
      img.opacity-100.h-2_75(v-if='domainConfig.assets.logo', :src='domainConfig.assets.logo', alt='Home')
      .h-2_75(v-else)
</template>